export default {
  center: null, // center of the map { lat: number, lng: number }
  zoom: null,

  // watchid: null,
  position: null,

  weather: {},

  // to remove? pois are stored in db
  pois: {}, // dict of all pois
  poisIdx: [], // ids of pois
  poisTrack: JSON.parse(localStorage.getItem('pois-track')) || false, // wether to track points when map moves
  poisOrigins: [] // array of latlng of requests
}
